module.exports = __webpack_public_path__ + "static/media/Calendar.b54eaeb3.svg";